// extracted by mini-css-extract-plugin
export default {"roles__table":"RolePermission_roles__table__WZHRv"};